<template>
  <main class="container-card cursor-pointer" @click="clickCrewCard()">
    <div :class="['crew-card', activeCard == crew.nik ? 'active-card' : '']">
      <div class="courier-info d-flex">
        <div class="courier-avatar">
          <img
            src="~/assets/images/Ic_Karyawan_Toko_APO.png"
            alt="Rudy Santoso"
            class="rounded-circle"
          />
        </div>
        <div class="courier gap-2">
          <div class="courier-details gap-2 d-flex align-items-center">
            <div class="courier-name text-truncate">{{ crew.name }}</div>
            <span class="dot" />
            <div class="courier-nik">{{ crew.nik }}</div>
          </div>
          <div
            :class="[
              'badge-status',
              'badge-delivered',
              getStatusClass(crew.status ?? 0),
            ]"
          >
            {{ getStatusText(crew.status ?? 0) }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import {
  useCrewTracking,
  type IProcessedCrewData,
} from "~/composables/Tracking/useCrewTracking";
import { getStatusText } from "~~/constant/StatusCodes";
const { handleSelectCrew, activeCard } = useCrewTracking();

const props = defineProps<{ crew: IProcessedCrewData }>();

const clickCrewCard = () => {
  handleSelectCrew(props.crew);
};

const getStatusClass = (statusCode: number): string => {
  switch (statusCode) {
    case 3001:
      return "status-available";
    case 3002:
      return "status-sedang-mengirim";
    case 3003:
      return "status-sedang-transit";
    case 3004:
      return "status-kembali-ke-toko";
    default:
      return "status-unknown";
  }
};
</script>

<style lang="scss" scoped>
/* Variabel Warna */
$color-card-bg: #fff;
$color-border-light: #d8d8d8;
$color-text-dark: #333;
$color-text-secondary: #777;
$color-avaliable-dark: #00a993;
$color-avaliable-light: #ddfffb;
$color-button-delivered-bg: #ecedff;
$color-button-delivered-text: #6a0dad;
$color-button-transit-dark: #ff7e00;
$color-button-transit-light: #ffe5cc;
$color-button-kembali-toko-dark: #aa8d00;
$color-button-kembali-toko-light: #fff6cc;

.crew-card {
  background-color: $color-card-bg;
  border-radius: 15px;
  padding: 8px;
  font-family: sans-serif;
  max-width: 380px;
  border: 2px solid $color-border-light;
  cursor: pointer;

  &.active-card {
    border: 2px solid #d00b0b;
    transition: ease-in 0.3s;
  }

  .courier-info {
    display: flex;
    gap: 15px;
    .courier-avatar {
      width: 35px;
      height: 35px;
      overflow: hidden;
      border: 1px solid $color-border-light;
      border-radius: 50%;
      & img {
        object-fit: cover;
        width: 35px;
        height: 35px;
      }
    }
    .courier {
      display: flex;
      flex-direction: column;

      .courier-details {
        .courier-name {
          max-width: 150px;
          font-weight: bold;
          text-wrap: nowrap;
          color: $color-text-dark;
        }

        .dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          display: inline-block;
          z-index: 1;
          background-color: #999999;
        }

        .courier-nik {
          font-size: 0.9em;
          color: $color-text-secondary;
        }
      }

      .badge-status {
        width: fit-content;
        padding: 4px 8px;
        transition: background-color 0.2s;
        border-radius: 8px;
        font-weight: 530;
        color: #9866ca;
        font-size: 14px;
        cursor: normal;
      }
      .badge-delivered {
        background-color: $color-button-delivered-bg;
        color: $color-button-delivered-text;
        border: 1px solid #9866ca;

        // &:hover {
        //   background-color: darken($color-button-delivered-bg, 5%);
        // }
        &.status-available {
          // Jika statusnya "Available"
          background-color: $color-avaliable-light;
          color: $color-avaliable-dark;
          border-color: $color-avaliable-dark;

          // &:hover {
          //   background-color: darken($color-avaliable-light, 15%);
          // }
        }
        &.status-sedang-transit {
          background-color: $color-button-transit-light;
          color: $color-button-transit-dark;
          border-color: $color-button-transit-dark;

          // &:hover {
          //   background-color: darken($color-button-transit-light, 7%);
          // }
        }
        &.status-kembali-ke-toko {
          background-color: $color-button-kembali-toko-light;
          color: $color-button-kembali-toko-dark;
          border-color: $color-button-kembali-toko-dark;

          // &:hover {
          //   background-color: darken($color-button-kembali-toko-light, 10%);
          // }
        }
        &.status-unknown {
          background-color: $primary;
          color: white;
          border: white;
        }
      }
    }
  }
}
</style>
